import { FC } from 'react';

import { ActEditingField } from 'utils/constants/admin';

import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import { EditingData } from 'components/Admin/Reports/ActsReport/EditingActsTable/EditingAct/EditingAct';
import EditingSelectorField from 'components/Admin/Reports/ActsReport/EditingActsTable/EditingAct/EditingSelectorField/EditingSelectorField';
import { ActSendStatus } from 'components/Admin/Reports/ActsReport/Labels';

import {
    Act,
    ActAdvertisingServiceType as ActAdvertisingServiceTypeEnum,
    ActSendStatus as ActSendStatusEnum,
} from 'store/models/acts';

import styles from 'components/Admin/Reports/ActsReport/ActsTable/Act/Act.module.less';

interface SendStatusProps {
    act: Act;
    onChange: (field: ActEditingField, value: string | undefined) => void;
    values: EditingData;
}
const SendStatus: FC<SendStatusProps> = ({ act, onChange, values }) => {
    const { advertisingServiceType, actSendStatus, sentAt } = act;
    const trl = useTrls();

    const isAdvertisingType = advertisingServiceType === ActAdvertisingServiceTypeEnum.Advertising;
    const canEditing = actSendStatus === ActSendStatusEnum.New || actSendStatus === ActSendStatusEnum.Ignored;

    const dict = [
        {
            value: ActSendStatusEnum.New,
            label: trl('admin.actsReport.actsTable.sendStatus.new'),
        },
        {
            value: ActSendStatusEnum.Ignored,
            label: trl('admin.actsReport.actsTable.sendStatus.ignored'),
        },
    ];

    return isAdvertisingType ? (
        <>
            <div className={styles.tableCellGroup}>
                <b>{trl('admin.actsReport.actsTable.label.sendStatus')}: </b>
                {canEditing ? (
                    <EditingSelectorField
                        value={actSendStatus}
                        newValue={values[ActEditingField.SendStatus]}
                        setNewValue={(value) => onChange(ActEditingField.SendStatus, value)}
                        resetNewValue={() => onChange(ActEditingField.SendStatus, undefined)}
                        dictionary={dict}
                    >
                        <ActSendStatus sendStatus={actSendStatus} />
                    </EditingSelectorField>
                ) : (
                    <ActSendStatus sendStatus={actSendStatus} />
                )}
            </div>
            <VSpacing base={1} />
            <div className={styles.tableCellGroup}>
                <b>{trl('admin.actsReport.actsTable.label.sentAt')}: </b>
                <span>{sentAt}</span>
            </div>
        </>
    ) : null;
};

export default SendStatus;
